// libs
import styled from 'styled-components'
// components
import StepperOrigin from '@mui/material/Stepper'
// themes
import { colors } from 'themes'

const ButtonWrapper = styled.div`
  align-items: center;
  background-color: ${colors.gray200};
  display: flex;
  height: 56px;
  width: 100%;
`

const Stepper = styled((props) => <StepperOrigin {...props} />)`
  > :last-child {
    ${({ activeStep }) => activeStep === 0 && 'margin-right: 100px'}
  }

  .disabled > .stepLabel {
    display: none;
  }
`

const BUTTON_STYLE = {
  marginLeft: '20px',
  borderRadius: '30px',
  minWidth: '87px'
}

export { ButtonWrapper, Stepper, BUTTON_STYLE }
